import { Autocomplete, Button, TextField } from "@mui/material";
import { MultiAssignProps } from "./MultiAssign.types";

export function MultiAssign<T, ID extends string | number>({
    options,
    loadingOptions = false,
    selectedIds,
    onChange,
    getOptionLabel,
    getOptionValue,
    onSave,
    saving = false,
    label = "Wybierz",
    placeholder = "",
}: MultiAssignProps<T, ID>) {

    const value = options.filter((opt) =>
        selectedIds.includes(getOptionValue(opt))
    );

    return (
        <>
            <Autocomplete
                multiple
                options={options}
                getOptionLabel={getOptionLabel}
                isOptionEqualToValue={(opt, val) =>
                    getOptionValue(opt) === getOptionValue(val)
                }
                value={value}
                loading={loadingOptions}
                onChange={(_, newVals) =>
                    onChange(newVals.map((v) => getOptionValue(v)))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        placeholder={placeholder}
                        margin="normal"
                        fullWidth
                    />
                )}
            />

            <Button
                variant="contained"
                onClick={onSave}
                disabled={saving}
                sx={{ mt: 2 }}
            >
                {saving ? "Zapisuję..." : "Zapisz"}
            </Button>
        </>
    );
}